
export { MinifiedSideMenu } from "/home/runner/_work/play/play/apps/play-portal/src/components/core/sidemenu/MinifiedSideMenu.tsx"